var companyId = 'zentexus123';

export default companyId;